import { gql } from '@apollo/client'

export const GET_LIST_AUCTION_PLAYER = gql`
  query ListAuctionPlayerFront($input: oListAuctionPlayerInput!) {
    listAuctionPlayerFront(input: $input) {
      nTotal
      sMessage
      aData {
        _id
        nBasePrice
        nSoldPrice
        bCappedPlayer
        oTeam {
          sAbbr
          oImg {
            sUrl
            sText
          }
        }
        eAuctionStatus
        oPrimaryTeam {
          sTitle
          oImg {
            sUrl
            sText
          }
          oJersey {
            sUrl
            sText
          }
        }
        oPlayer {
          sFullName
          oImg {
            sUrl
            sText
          }
        }
        oCountry {
          sTitle
          oImg {
            sUrl
            sText
          }
        }
        sPlayingRole
      }
    }
  }
`
export const GET_AUCTION_PLAYER_DETAIL = gql`
  query GetAuctionPlayerFront($input: oGetAuctionPlayerFrontInput!) {
    getAuctionPlayerFront(input: $input) {
      oData {
        nBasePrice
        nSoldPrice
        bCappedPlayer
        bOverseas
        oTeam {
          sAbbr
          oImg {
            sUrl
            sText
          }
        }
        eAuctionStatus
        oPrimaryTeam {
          sTitle
          oImg {
            sUrl
            sText
          }
          oJersey {
            sUrl
            sText
          }
        }
        oPlayer {
          sFullName
          oImg {
            sUrl
            sText
          }
          oSeo {
            sSlug
          }
        }
        oCountry {
          sTitle
          oImg {
            sUrl
            sText
          }
        }
        sPlayingRole
        aBid {
          _id
          nSoldPrice
          nBidPrice
          bSold
          bRTM
          oTeam {
            sTitle
            oImg {
              sUrl
              sText
            }
          }
        }
      }
    }
  }
`
